import ScheduleViewDoctors from "./Doctors";

import PropTypes from 'prop-types';

import { ReactComponent as ArrowIcon } from 'icons/components/arrow.svg';
import { ReactComponent as ClockIcon } from 'icons/pages/app/clock.svg';

import './index.less';
import './visitsMap.less';
import './themes/default.less';

const intPxMap = {
    5: 120,
    10: 120,
    15: 120,
    30: 120,
    60: 84,
    120: 48,
};

export default class ScheduleViewMainView extends ScheduleViewDoctors {
    static propTypes = {
        info: PropTypes.object,
        timeLabel: PropTypes.string,
        getDoctorById: PropTypes.func,
    };

    static defaultProps = {
        info: {},
        timeLabel: "",
        getDoctorById: null,
    };

    constructor(props) {
        super(props);

        this.currentList = 0;
        this.savedScrollPosition = null;
        this.savedListPosition = 0;
    }

    componentDidMount() {

        this._helper.disconnect(this.windowResize);
        this.windowResize = this._helper.on(window, "resize", this.clearListProp.bind(this));

        this.onRendered();
    }

    componentWillUnmount() {
        this._helper.disconnect(this.windowResize);
    }

    componentDidUpdate() {
        this.savedListPosition = this.currentList;

        if (this.domNode) {
            this.savedScrollPosition = {
                left: this.domNode.scrollLeft,
                top: this.domNode.scrollTop,
            };
        }

        if (this.domNode && this.savedScrollPosition) {
            this.domNode.scrollTo(
                this.savedScrollPosition.left,
                this.savedScrollPosition.top
            );
        }

        this.onRendered();
        this.clearListProp();

        this.setList(this.savedListPosition);
    }

    resetScrollAndPosition() {
        this.currentList = 0;
        this.savedScrollPosition = { left: 0, top: 0 };

        if (this.domNode) {
            this.domNode.scrollTo(0, 0);
        }

        this.setList(0);
    }

    onRendered() {
        this.setTimeLine();

        const lCount = this.headerItemsNode?.querySelectorAll(".item").length || 0;
        if (lCount)
            this.slideItems(lCount, 0);
    }

    clearListProp() {
        this.setList(0);
    }

    getPercentFromTimes(date, date2) {
        const m = (date.getHours() * 60) + date.getMinutes();
        const m2 = (date2.getHours() * 60) + date2.getMinutes();

        return (m2 - m) / this.timeMins;
    }

    setTimeLine() {
        const start = this.getPercentFromTimes(this.startTime, new Date());

        this._helper.dom.styleProp(this.timeLine, "from", start);
    }

    slideItems(count, flag) {
        const { buferOpened } = this.props.info;
        const { w } = this._helper.dom.coords(document.body);
        const isMiddleScreen = w < 1440;
        const isSmallScreen = w < 1280;
        const isLargeScreen = w > 1600;
        let listed = this.currentList;

        listed = parseInt(listed) || 0;
        listed += flag;

        let onePage = 4;
        if (isLargeScreen) {
            onePage = 6; // 6 кабинетов на больших экранах
        } else if (isSmallScreen && buferOpened) {
            onePage = 1;
        } else if (isSmallScreen && !buferOpened) {
            onePage = 2;
        } else if ((!isMiddleScreen && buferOpened) || (isMiddleScreen && !buferOpened)) {
            onePage = 3;
        } else if (isMiddleScreen && buferOpened) {
            onePage = 2;
        }

        if (flag < 0 && listed < 0)
            listed = 0;
        else if (count >= onePage && listed + onePage > count)
            listed = count - onePage;

        this.setList(listed);
    }

    setList(list) {
        this.currentList = list;
        this._helper.dom.styleProp(this.domNode, "list", list);
    }

    insertArrow(count, isLeft = true) {
        const cl = isLeft ? "left rotate180" : "right";

        return (
            <div
                className={"arrow pos abs hand flex centerAll " + cl}
                onClick={this.slideItems.bind(this, count, isLeft ? - 1 : 1)}
            >
                <ArrowIcon />
            </div>
        );
    }

    getIntervalsLines(minutes, startDate, end) {
        const intervals = [];
        const lines = [];
        const start = new Date(startDate);

        while (start.getTime() <= end.getTime()) {
            const time = this._helper.date.toStr(start, "HH:mm");

            intervals.push((
                <div key={time} className="interval">
                    <div className="label text p1">{time}</div>
                </div>
            ));

            lines.push((
                <div key={time} className="line"></div>
            ));

            start.setMinutes(start.getMinutes() + minutes);
        }

        return { intervals, lines };
    }

    renderHeader(labels) {
        const count = labels.length;

        return (
            <div className="header flex">
                <div className="times"></div>
                <div className="items pos rel flex1 flex" ref={el => this.headerItemsNode = el}>
                    {labels.map((text, i) => {
                        return (
                            <div key={i} className="item flex1 text p1">{text}</div>
                        );
                    })}
                    {this.insertArrow(count)}
                    {this.insertArrow(count, false)}
                </div>
            </div>
        );
    }

    render() {
        const { info, getDoctorById } = this.props;
        const { currentDoctor, date, cabinets, selectedCabinets, buferOpened, intervalSchedules, currentTime, currentDays, visits, editDoctorsMode, canceledMode } = info;
        const count = currentDoctor ? currentDays : selectedCabinets.length;
        const booferCl = buferOpened ? " booferActive" : "";
        const canceledCl = canceledMode ? "isCanceled" : "";

        this.isFullDay = currentTime === 120;
        this.intPx = intPxMap[currentTime];
        this.timeMins = this.isFullDay ? 60 : currentTime;

        let labels = [];
        let doctorsOnDay = [];
        let doctorVisits = [];

        const startDef = this._helper.date.addDays(null, 10);
        let start = this._helper.date.create(startDef);

        const endDef = this._helper.date.addDays(null, -10);
        let end = this._helper.date.create(endDef);

        this.currentDoctorVisits = {};
        this.visitsNodes = {};
        this.doctorsNodes = {};

        if (currentDoctor) {
            const doctor = getDoctorById(currentDoctor);
            const doctorShs = intervalSchedules.filter(it => it.doctorId === currentDoctor);

            let startDate = new Date(date.getTime());
            for (let i = 0; i < count; i++) {
                labels.push(this._helper.date.toTodayStr(startDate));
                /*const doctorSh = doctorShs.find(it => {
                    const docShDate = new Date(it.beginDate);
                    const res = this._helper.date.equealDates(startDate, docShDate);
                    return res;
                });*/

                const arr = [];
                //let tempBegin = new Date();

                doctorShs.forEach(it => {
                    const docShDate = new Date(it.beginDate);
                    const res = this._helper.date.equealDates(startDate, docShDate);

                    if (res) {
                        const doctorSh = it;
                        if (doctorSh) {
                            const originalBeginTime = doctorSh?.beginDate;
                            const originalEndTime = doctorSh?.endDate;
                            const cabinetId = doctorSh?.cabinetId;
                            const assistantId = doctorSh?.assistantId;
                            //const shId = doctorSh?.id;
                            const shId = doctorSh?.parent?.id;

                            const tempBegin = this._helper.date.getTimeToday(originalBeginTime);
                            const tempEnd = this._helper.date.getTimeToday(originalEndTime);

                            if (tempBegin.getTime() < start.getTime())
                                start = tempBegin;
                            if (tempEnd.getTime() > end.getTime())
                                end = tempEnd;

                            arr.push({ ...doctor, originalBeginTime, originalEndTime, cabinetId, assistantId, shId, time: tempBegin.getTime() });
                        }

                    }

                });

                doctorsOnDay.push(arr);

                //const doctorVisOnDay = { [`${currentDoctor} + ${tempBegin.getTime()}`]: [] };
                const doctorVisOnDay = {};
                visits.forEach(vis => {
                    const visStart = this._helper.date.fromStr(vis.beginDate);
                    const visEnd = this._helper.date.fromStr(vis.endDate);

                    /*if (this._helper.date.equealDates(startDate, visStart))
                        doctorVisOnDay[`${currentDoctor} + ${tempBegin.getTime()}`].push(vis);*/

                    doctorsOnDay[i].forEach((shift, ind) => {
                        const tempBegin = this._helper.date.getTimeToday(shift.originalBeginTime);
                        const bd = this._helper.date.fromStr(shift.originalBeginTime);
                        const ed = this._helper.date.fromStr(shift.originalEndTime);
                        const exceeds = this._helper.date.intervalExceedsBounds(bd, ed, visStart, visEnd);
                        const equealDates1 = this._helper.date.intervalsOverlap(shift.originalBeginTime, shift.originalEndTime, vis.beginDate, vis.endDate);

                        if (!doctorVisOnDay[`${currentDoctor} + ${tempBegin.getTime()}`])
                            doctorVisOnDay[`${currentDoctor} + ${tempBegin.getTime()}`] = [];

                        if (shift.id === currentDoctor && shift.cabinetId === vis.cabinetId && !exceeds && equealDates1) {
                            doctorVisOnDay[`${currentDoctor} + ${tempBegin.getTime()}`].push(vis);
                        }

                    });
                    /*doctorShs.forEach((shift, ind) => {
                        const bd = this._helper.date.fromStr(shift.beginDate);
                        const ed = this._helper.date.fromStr(shift.endDate);
                        const exceeds = this._helper.date.intervalExceedsBounds(bd, ed, visStart, visEnd);
                        const equealDates = this._helper.date.equealDates(startDate, visStart);

                        const equealDates1 = this._helper.date.intervalsOverlap(shift.beginDate, shift.endDate, vis.beginDate, vis.endDate);

                        if (shift.doctorId === currentDoctor && shift.cabinetId === vis.cabinetId && !exceeds && equealDates1)
                            doctorVisOnDay[`${currentDoctor} + ${tempBegin.getTime()}`].push(vis);
                    });*/

                });
                doctorVisits.push(doctorVisOnDay);

                startDate = this._helper.date.addDays(startDate, 1);
            }
        } else {
            cabinets.filter(it => selectedCabinets.includes(it.id)).forEach(cab => {
                labels.push(cab.title);

                const doctorsInCab = [];
                const doctorVisOnDay = {};

                intervalSchedules.filter(sh => sh.cabinetId === cab.id).forEach(sh => {
                    const originalBeginTime = sh?.beginDate;
                    const originalEndTime = sh?.endDate;
                    const cabinetId = sh?.cabinetId;
                    const assistantId = sh?.assistantId;
                    const shId = sh.parent?.id;
                    const parentId = sh?.parentId;

                    const tempBegin = this._helper.date.getTimeToday(originalBeginTime);
                    const tempEnd = this._helper.date.getTimeToday(originalEndTime);

                    if (tempBegin.getTime() < start.getTime())
                        start = tempBegin;
                    if (tempEnd.getTime() > end.getTime())
                        end = tempEnd;

                    const docId = sh.doctorId;
                    const doctor = getDoctorById(docId);

                    if (doctor) {
                        doctorsInCab.push({ ...doctor, originalBeginTime, originalEndTime, cabinetId, assistantId, shId, parentId, time: tempBegin.getTime() });

                        visits.forEach(vis => {
                            if (vis.cabinetId === cab.id && vis.doctorId === doctor.id) {

                                const equealDates = this._helper.date.intervalsOverlap(sh?.beginDate, sh?.endDate, vis.beginDate, vis.endDate);

                                if (!doctorVisOnDay[`${doctor.id} + ${tempBegin.getTime()}`])
                                    doctorVisOnDay[`${doctor.id} + ${tempBegin.getTime()}`] = [];

                                if (equealDates)
                                    doctorVisOnDay[`${doctor.id} + ${tempBegin.getTime()}`].push(vis);
                            }
                        });

                    }
                });

                doctorsOnDay.push(doctorsInCab);
                doctorVisits.push(doctorVisOnDay);
            });
        }

        start = this._helper.date.getTimeToday((editDoctorsMode || startDef.getTime() === start.getTime()) ? this._config.workDayStart : start);
        end = this._helper.date.getTimeToday((editDoctorsMode || endDef.getTime() === end.getTime()) ? this._config.workDayEnd : end);

        this.startTime = start;
        this.endTime = end;

        const { intervals, lines } = this.getIntervalsLines(this.timeMins, start, end);

        return (
            <div
                ref={el => this.domNode = el}
                className={"scheduleView flex1 scrolling" + booferCl}
                style={{ "--list": 0 }}
            >
                <div className="pos rel flex col minH100">
                    {this.renderHeader(labels)}
                    <div className={`container flex1 flex hidden m${currentTime} ${canceledCl}`} style={{ "--intPx": this.intPx + "px" }}>
                        <div className="times">
                            {intervals}
                        </div>
                        <div className="itemsCont pos rel flex1 flex">
                            <div className="lines pos abs">
                                {lines}
                            </div>
                            <div ref={el => this.timeLine = el} className="timeLine curr pos abs" style={{ "--from": -1 }}>
                                <ClockIcon />
                            </div>
                            <div ref={el => this.timeLinePointer = el} className="timeLine pos abs" style={{ "--from": -1 }}>
                                <div ref={el => this.timeLinePointerLabel = el} className="label pos abs text p1 rad8"></div>
                            </div>
                            <div className="items flex1 flex hidden" ref={el => this.itemsNode = el}>
                                {labels.map((label, i) => {
                                    return (
                                        <div key={i} className="item pos rel flex1 text p1">
                                            {doctorsOnDay[i].map(it => {
                                                return this.insertDoctor(it, start, end, doctorVisits[i][`${it.id} + ${it.time}`]);
                                            })}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
